import type { EnvironmentConfig } from '../types';

// Environment configuration with validation
export const config: EnvironmentConfig = {
    apiBaseUrl: import.meta.env.VITE_API_BASE_URL || 'http://localhost:3000',
    cognitoUserPoolId: import.meta.env.VITE_COGNITO_USER_POOL_ID || '',
    cognitoClientId: import.meta.env.VITE_COGNITO_CLIENT_ID || '',
    region: import.meta.env.VITE_AWS_REGION || 'us-east-1',
    stage: (import.meta.env.VITE_STAGE as 'dev' | 'staging' | 'prod') || 'dev',
};

// Validate required environment variables
export function validateConfig(): void {
    const requiredVars = [
        { key: 'VITE_COGNITO_USER_POOL_ID', value: config.cognitoUserPoolId },
        { key: 'VITE_COGNITO_CLIENT_ID', value: config.cognitoClientId },
        { key: 'VITE_API_BASE_URL', value: config.apiBaseUrl },
    ];

    const missingVars = requiredVars.filter(({ value }) => !value);

    if (missingVars.length > 0) {
        const missing = missingVars.map(({ key }) => key).join(', ');
        throw new Error(`Missing required environment variables: ${missing}`);
    }
}

// Application constants
export const APP_CONFIG = {
    name: import.meta.env.VITE_APP_NAME || 'Tenant Management UI',
    version: import.meta.env.VITE_APP_VERSION || '1.0.0',
    pagination: {
        defaultLimit: 20,
        maxLimit: 100,
    },
    debounce: {
        searchDelay: 300,
    },
    timeouts: {
        apiRequest: 30000,
        tokenRefresh: 5000,
    },
} as const;
